import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_layout/(deprecated)/subscriptions/$')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: location.pathname.replace('/subscriptions', '/workspaces'), search: true, replace: true })
  },
})
